module.exports = __webpack_public_path__ + "static/media/facebook.03c3adf6.png";